import { render } from "./copyTaskProj.vue?vue&type=template&id=d58e32e4"
import script from "./copyTaskProj.vue?vue&type=script&lang=js"
export * from "./copyTaskProj.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__